import React from 'react';

import { fg } from '@confluence/feature-gating';
import { LoadableLazy } from '@confluence/loadable';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { TransparentErrorBoundary } from '@confluence/error-boundary/entry-points/TransparentErrorBoundary.ts';

const LazyPostOfficeRovoNudgePlacement = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConfluencePostOfficeRovoNudgePlacement" */ './PostOfficeRovoNudgePlacement.tsx'
			)
		).PostOfficeRovoNudgePlacement,
});

export const RovoNudgePlacement = ({
	contentType,
	pageMode,
	isDisabled,
}: {
	contentType: string;
	pageMode: string;
	isDisabled: boolean;
}): React.JSX.Element | null =>
	!isDisabled &&
	contentType === 'page' &&
	pageMode === 'view' &&
	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Roll out the nudge placement independently from the catch-up skill.
	fg('confluence_rovo_nudge_placement_integration') ? (
		<TransparentErrorBoundary attribution={Attribution.AI_MATE}>
			<LazyPostOfficeRovoNudgePlacement />
		</TransparentErrorBoundary>
	) : null;
